import { createPortal } from "react-dom";
import type { ReactNode } from "react";
import { isCoarsePointerDevice } from "./fireflyIdleRoaming";
import { FIREFLY_DEFAULT_PORTAL_Z } from "@/lib/firefly/fireflyTourLayerZIndex";

export function FireflyViewportPortal(props: {
  viewportX: number;
  viewportY: number;
  children: ReactNode;
  /** When false, position updates instantly (rAF chase). Default true. */
  smoothTransition?: boolean;
  /** Stacking order for portaled firefly layers. Default: dock/lab layer. */
  zIndex?: number;
}) {
  const { viewportX, viewportY, children, smoothTransition = true, zIndex = FIREFLY_DEFAULT_PORTAL_Z } = props;
  if (typeof document === "undefined") return null;

  const coarse = isCoarsePointerDevice();
  const transition = smoothTransition
    ? coarse
      ? "left 4s ease-in-out, top 4s ease-in-out"
      : "left 90ms ease-out, top 90ms ease-out"
    : undefined;

  return createPortal(
    <div
      aria-hidden
      className="pointer-events-none"
      style={{ position: "fixed", inset: 0, zIndex }}
    >
      <div
        style={{
          position: "absolute",
          left: viewportX,
          top: viewportY,
          transition,
        }}
      >
        {children}
      </div>
    </div>,
    document.body,
  );
}
